module.exports = __webpack_public_path__ + "media/images/allow-e4fdf26cdcef86f4a1eb661f54ad9bd3.svg";